// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blocked {\n  opacity: 0.5;\n  pointer-events: none;\n}[dir] .blocked {\n  cursor: none;\n}\n", ""]);
// Exports
module.exports = exports;
